<template>
  <footer class="mt-auto footer-shell">
    <v-sheet color="secondary">
      <v-container class="py-5 py-md-7">
        <div
          class="justify-center grid-list"
          :class="{ 'justify-lg-space-between': menu.length }"
        >
          <div
            class="d-flex align-center justify-space-between justify-md-center"
          >
            <v-btn
              class="text-none px-0"
              color="transparent"
              :exact="false"
              to="/"
              :height="smAndDown ? '42px' : '61px'"
              depressed
              plain
            >
              <img
                v-if="informations.img"
                class="d-block rounded-pill item-img"
                :src="files + informations.img"
                :alt="informations.name"
                :height="smAndDown ? '42px' : '61px'"
                :width="smAndDown ? '42px' : '61px'"
              />

              <span
                class="white--text text-body-1 text-md-h6 font-weight-bold ml-2"
              >
                {{ informations.short_name }}
              </span>
            </v-btn>

            <PwaButtonWidget v-if="smAndDown" />
          </div>

          <template v-if="menu.length || social.length || !smAndDown">
            <div
              class="
                d-flex
                flex-wrap
                align-center
                justify-center justify-lg-end
              "
            >
              <template v-if="menu.length">
                <template v-for="({ text, bind }, keyMenu) in menu">
                  <v-btn
                    :key="keyMenu"
                    class="white--text text-body-1 text-none font-weight-medium"
                    v-bind="bind"
                    text
                    tile
                  >
                    {{ text }}
                  </v-btn>
                </template>
              </template>

              <PwaButtonWidget v-if="!smAndDown" />

              <template v-if="social.length">
                <template v-for="{ link, icon } in social">
                  <v-btn
                    :key="link"
                    :href="link"
                    target="_blank"
                    color="transparent"
                    depressed
                    small
                    fab
                  >
                    <v-icon color="white">
                      {{ icon }}
                    </v-icon>
                  </v-btn>
                </template>
              </template>
            </div>
          </template>
        </div>
      </v-container>
    </v-sheet>

    <v-sheet class="pt-4 footer-aditional-padding" color="secondary darken-1">
      <div class="text-center">
        <v-btn
          class="text-body-1 text-none font-weight-bold rounded-lg"
          color="white"
          href="https://www.mrxweb.com.br/contato"
          target="_blank"
          depressed
          outlined
        >
          Crie seu Catálogo
        </v-btn>
      </div>

      <div class="white--text text-body-2 text-center mt-3">
        <b>MeuCatálogo</b> desenvolvido por MRX
      </div>
    </v-sheet>
  </footer>
</template>

<script>
import PwaButtonWidget from "../widgets/PwaButtonWidget.vue";
import { getMenu } from "../../utils/getMenu";
import { getSocial } from "../../utils/getSocial";

export default {
  created() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });

    this.$rest("howBuy").get({
      save: (state, data) => (state.item = data),
    });
  },
  computed: {
    config() {
      return this.$rest("config").item;
    },
    informations() {
      return this.$rest("informations").item;
    },
    about() {
      return this.$rest("about").item;
    },
    howBuy() {
      return this.$rest("howBuy").item;
    },
    social() {
      return getSocial(this.informations);
    },
    menu() {
      const component = {
        config: this.config,
        about: !!this.about.text,
        howBuy: !!this.howBuy.text,
      };

      return getMenu(component);
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  components: {
    PwaButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 20px;
  grid-template-columns: min-content 1fr;

  @media screen and (max-width: 1264px) {
    grid-template-columns: 1fr;
  }
}

.footer-aditional-padding {
  padding-bottom: 90px;
}
</style>
